export default __webpack_public_path__ + "static/media/fees.4272be6d.svg";